/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2024 - All Rights Reserved
###################################################################
*/
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */

import React from 'react';
import { useHistory } from 'react-router-dom';

import FormContainer from 'components/FormContainer';
import { FormSectionGlobal as FormSection } from '@fitinsur/components';
import { Icon } from '@fitinsur/components';

import { GeneralSection } from '../../general/index';
import { ContactsSection } from '../index';

function RenderSection({
  idPerson,
  formikProps,
  formikRef,
  idProduct,
  globalQuestionnaire,
  setGlobalQuestionnaire,
  contactsGroup,
  setContactsGroup,
  contactsGroupToDelete,
  setContactsGroupToDelete
}) {
  const setStateContacts = (questionnaire, sectionIndex, index) => setContactsGroup(
    contactsGroup.map((group, groupIndex) => {
      if (groupIndex === sectionIndex) {
        return {
          ...group,
          contacts: group.contacts.map(
            (contactGroup, contactGroupIndex) => contactGroupIndex === index ? questionnaire : contactGroup
          )
        }
      }
      return group;
    }
    ));

  return (
    <FormContainer show={true} title="Contacts" minHeight={"351px"}>
      {contactsGroup.map((team, sectionIndex) => (
        <FormContainer show={true} key={team.idPersonTeam} collapsedAtStart title={team?.teamName}>
          {team.contacts.map((questions, index) => (
            <FormSection
              key={index}
              sectionIndex={index}
              sectionName="CONTACTS"
              errors={formikProps.errors}
              questionnaire={questions}
              setQuestionnaire={(questionnaire) => setStateContacts(questionnaire, sectionIndex, index)}
              values={formikProps.values}
              setFieldValue={formikProps.setFieldValue}
              setFieldError={formikProps.setFieldError}
              formikRef={formikRef}
              idProduct={idProduct}
              operationIdPerson={idPerson}
              selectedPersons={
                team.contacts.map(contactQuestions => {
                  const contactAnswer = contactQuestions.find(qst => qst.idQuestion === 2189)?.answer;
                  return JSON.parse(contactAnswer || '{}')?.id;
                }).filter(idPerson => idPerson)
              }
              extraButtons={() => {
                return renderSectionAddAndRemoveRowButtons({
                  sectionState: contactsGroup,
                  setSectionState: setContactsGroup,
                  sectionIndex,
                  contactIndex: index,
                  contactsGroupToDelete,
                  setContactsGroupToDelete
                });
              }}
              onQuestionChange={(
                question,
                value,
                setFieldValue,
                questionnaireUpdated,
              ) =>
                ContactsSection.events.handleQuestionChange({
                  question,
                  value,
                  setFieldValue,
                  questionnaireUpdated,
                  setQuestionnaireUpdated: (questionnaire) => setStateContacts(questionnaire, sectionIndex, index),
                })
              }
            />
          ))}
        </FormContainer>
      ))}
    </FormContainer>
  )
}

function renderSectionAddAndRemoveRowButtons({
  sectionState,
  setSectionState,
  sectionIndex,
  contactIndex,
  contactsGroupToDelete,
  setContactsGroupToDelete,
  // questionnaireAnswersToDelete,
  // setQuestionnaireAnswersToDelete,
  onRemove = null
}) {
  const history = useHistory();

  const contactGroup = sectionState[sectionIndex].contacts[contactIndex];
  const contactAnswer = sectionState[sectionIndex].contacts[contactIndex]?.find(
    qst => qst.idQuestion === 2189
  )?.answer;
  const contactIdPerson = JSON.parse(contactAnswer || '{}')?.id;

  return (
    <>
      {contactIdPerson &&
        <GeneralSection.components.Styled.IconButton style={{ marginBottom: '15px' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            history.push(`/management/person/${contactIdPerson}`)
          }}
        >
          <Icon name="edit" style={{ margin: 0 }} />
        </GeneralSection.components.Styled.IconButton>
      }

      {(contactIndex > 0 || contactGroup.some(({ answer }) => answer)) && (
        <GeneralSection.components.Styled.IconButton
          style={{ marginBottom: '15px' }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();

            const idPersonRelationshipContact = contactGroup.find(({ idQuestion }) => idQuestion === 2189)?.idPersonRelationship;
            if (idPersonRelationshipContact) setContactsGroupToDelete([...contactsGroupToDelete, idPersonRelationshipContact]);

            if (contactIndex == 0 && sectionState[sectionIndex].contacts.length == 1) {
              const newRow = GeneralSection.events.createSectionRow({ questions: contactGroup });

              setSectionState(sectionState.map((state, index) => {
                if (sectionIndex === index) {
                  return ({ ...state, contacts: [newRow] })
                }
                return state;
              }));
            } else {
              setSectionState(sectionState.map(state => {
                return ({ ...state, contacts: state.contacts.filter(contact => contact !== contactGroup) })
              }));
            }

            if (onRemove) {
              onRemove();
            }
          }}>
          <Icon name="trash" style={{ margin: 0 }} />
        </GeneralSection.components.Styled.IconButton>
      )}

      {(contactIndex === sectionState[sectionIndex].contacts.length - 1) && (
        <GeneralSection.components.Styled.IconButton onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          const newRow = GeneralSection.events.createSectionRow({ questions: contactGroup });

          setSectionState(sectionState.map((state, index) => {
            if (sectionIndex === index) {
              return ({ ...state, contacts: [...state.contacts, newRow] })
            }
            return state;
          }));
        }}>
          <Icon name="plus" style={{ margin: 0 }} />
        </GeneralSection.components.Styled.IconButton>
      )}
    </>
  )
}

const components = {
  RenderSection
};

export { components };